import redirectPermanently from '@/components/Redirect/redirectPermanently';

const OfficialScrumFundamentalsCertification = () =>
  redirectPermanently(
    '/certificaciones/official-scrum-fundamentals-certification'
  );

export default OfficialScrumFundamentalsCertification;
